/* eslint-disable @nx/enforce-module-boundaries */
import { Component, signal } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KanziUiModule } from '@kanzi-apes/kanzi-ui';
import { KanziPrimeUiModule, MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import { ItemsLayoutMainOptions } from '../../configs/main-menu';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'kanzi-apes-layout-main-view',
    imports: [
        CommonModule,
        KanziUiModule,
        KanziPrimeUiModule,
        TranslateModule,
        TitleCasePipe,
        RouterLink,
    ],
    templateUrl: './layout-main-view.component.html',
    styleUrls: ['./layout-main-view.component.scss']
})
export class LayoutMainViewComponent {
  itemsOptions = signal<MenuItem[]>(ItemsLayoutMainOptions);
}
